export default "__VITE_ASSET__Cx6yPj37__"